import React, { useState } from "react";

// Example event data structure
const events = [
  {
    title: "Sant Ravidas Jayanti",
    description:
      "Celebrating the birth anniversary of Sant Ravidas with community gatherings, prayers, and cultural programs.",
    images: [
      require("../assets/ravidas1.jpeg"),
      require("../assets/ravidas2.jpeg"),
      require("../assets/ravidas3.jpeg"),
      require("../assets/ravidas4.jpeg"),
      require("../assets/ravidas5.jpeg"),
      require("../assets/ravidas6.jpeg"),
      require("../assets/ravidas7.jpeg"),
      require("../assets/ravidas8.jpeg"),
      require("../assets/ravidas9.jpeg"),
      require("../assets/ravidas10.jpeg"),
      require("../assets/ravidas11.jpeg"),
      require("../assets/ravidas12.jpeg"),
      require("../assets/ravidas13.jpeg"),
      require("../assets/ravidas14.jpeg"),
      require("../assets/ravidas15.jpeg"),
      require("../assets/ravidas16.jpeg"),
      require("../assets/ravidas17.jpeg"),
      require("../assets/ravidas18.jpeg"),
      require("../assets/ravidas19.jpeg"),
      require("../assets/ravidas20.jpeg"),
      require("../assets/ravidas21.jpeg"),
      require("../assets/ravidas22.jpeg"),
      require("../assets/ravidas23.jpeg"),
      // Add more image paths as needed
    ],
  },
  // Add more events here
];

const Events: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [activeEventIdx, setActiveEventIdx] = useState<number | null>(null);
  const [activeImgIdx, setActiveImgIdx] = useState<number | null>(null);

  const openModal = (eventIdx: number, imgIdx: number) => {
    setActiveEventIdx(eventIdx);
    setActiveImgIdx(imgIdx);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setActiveEventIdx(null);
    setActiveImgIdx(null);
  };

  const showPrev = () => {
    if (activeEventIdx === null || activeImgIdx === null) return;
    setActiveImgIdx((prev) => {
      if (prev === null) return null;
      const total = events[activeEventIdx].images.length;
      return (prev - 1 + total) % total;
    });
  };

  const showNext = () => {
    if (activeEventIdx === null || activeImgIdx === null) return;
    setActiveImgIdx((prev) => {
      if (prev === null) return null;
      const total = events[activeEventIdx].images.length;
      return (prev + 1) % total;
    });
  };

  // Close modal on background click
  const handleModalBgClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) closeModal();
  };

  return (
    <section className="section-padding bg-white min-h-screen">
      <div className="container-custom">
        <div className="text-center mb-10">
          <h1 className="text-4xl md:text-5xl font-bold text-dark mb-4">
            Events
          </h1>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Explore our recent and upcoming events, each celebrated with great
            enthusiasm and community participation.
          </p>
        </div>
        {events.map((event, idx) => (
          <div key={idx} className="mb-16">
            <h2 className="text-2xl md:text-3xl font-bold text-primary mb-2">
              {event.title}
            </h2>
            <p className="text-gray-700 mb-6">{event.description}</p>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
              {event.images.map((img, imgIdx) => (
                <div
                  key={imgIdx}
                  className="bg-light rounded-lg overflow-hidden shadow-md cursor-pointer"
                  onClick={() => openModal(idx, imgIdx)}
                >
                  <img
                    src={img}
                    alt={`${event.title} photo ${imgIdx + 1}`}
                    className="w-full h-40 object-cover"
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Modal Lightbox */}
      {modalOpen && activeEventIdx !== null && activeImgIdx !== null && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 transition-all"
          onClick={handleModalBgClick}
        >
          <button
            className="absolute top-6 right-8 text-white text-3xl font-bold focus:outline-none"
            onClick={closeModal}
            aria-label="Close"
          >
            &times;
          </button>
          <button
            className="absolute left-4 md:left-12 text-white text-4xl font-bold px-2 py-1 focus:outline-none"
            onClick={showPrev}
            aria-label="Previous image"
          >
            &#8592;
          </button>
          <img
            src={events[activeEventIdx].images[activeImgIdx]}
            alt="Enlarged event"
            className="max-h-[80vh] max-w-[90vw] rounded-lg shadow-2xl border-4 border-white"
          />
          <button
            className="absolute right-4 md:right-12 text-white text-4xl font-bold px-2 py-1 focus:outline-none"
            onClick={showNext}
            aria-label="Next image"
          >
            &#8594;
          </button>
        </div>
      )}
    </section>
  );
};

export default Events;
